
import { Commerce } from 'src/app/models/commerce.model';
import * as fromCommerceModels from './commerce-public.action';

export interface commerceState {
    commerce: Commerce;
}

const estadoInicial: commerceState = {
    commerce: null
};


export function commerceReducer(state = estadoInicial, action: fromCommerceModels.acciones): commerceState {

    switch (action.type) {

        case fromCommerceModels.SET_COMMERCE:
            return {
                ...state,
                commerce: action.commerce
            };

        case fromCommerceModels.UNSET_COMMERCE:
            return {
                commerce: null
            };

        default:
            return state;

    }

}
